// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"120":"314f0ff4","161":"d7dacb08","251":"308a864d","491":"5227ff75","995":"ee73ee9e"}[chunkId] + ".js";
};